import { h } from 'preact';
import * as BaseComp from 'components/shared/header/header.js';
import { sortObjectByOrder } from 'utils/utils';
import s from 'components/shared/header/header.sss';

export default class Header extends BaseComp.default {
	renderNavItems() {
		const navItems = sortObjectByOrder(this.props.appData.header.nav, this.renderNavItem);
		const { customHeader } = this.props.appData.header;

		if (customHeader) {
			return <div class={s.customNav}>
				<div class={s.logo} />
				<div>
					{navItems}
				</div>
			</div>;
		}

		return navItems;
	} 
	render(props, state) {
		const baseRender = super.render(props, state);
		const { customHeader } = props.appData.header;
		
		if (customHeader) {
			return <div class={s.customHeader}>
				{baseRender}
			</div>;
		}

		return baseRender;
	}
}
